var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.013,
    height: 166,
    viewBox: "0 0 176.013 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot",
    transform: "translate(0 -0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_16_",
    transform: "translate(0 0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_17---Chat-Bot",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_96_",
    d: "M239.656,291.6a9.1,9.1,0,0,0,9.1-9.1H230.552A9.1,9.1,0,0,0,239.656,291.6Z",
    transform: "translate(-151.643 -185.395)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_29_",
    cx: 3.035,
    cy: 3.035,
    r: 3.035,
    transform: "translate(115.323 78.896)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_95_",
    d: "M182.552,167.739H146.138a30.345,30.345,0,0,0,0,60.69h36.414a30.345,30.345,0,1,0,0-60.69ZM134,201.119a9.1,9.1,0,1,1,9.1-9.1A9.1,9.1,0,0,1,134,201.119Zm30.345,21.242a15.172,15.172,0,0,1-15.173-15.173,6.087,6.087,0,0,1,6.069-6.069h18.207a6.087,6.087,0,0,1,6.069,6.069A15.173,15.173,0,0,1,164.345,222.36Zm30.345-21.242a9.1,9.1,0,1,1,9.1-9.1A9.1,9.1,0,0,1,194.69,201.119Z",
    transform: "translate(-76.333 -110.085)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_94_",
    d: "M223.932,418.222v16.386a86.934,86.934,0,0,1-34.745,7.859c-.546.03-1.123.03-1.669.03H187.4a87.961,87.961,0,0,1-36.293-7.89V418.222a12.138,12.138,0,0,1,12.138-12.138h9.1v12.138a15.172,15.172,0,0,0,15.173,15.173,13.23,13.23,0,0,0,1.548-.091,15.151,15.151,0,0,0,13.625-15.081V406.084h9.1A12.138,12.138,0,0,1,223.932,418.222Z",
    transform: "translate(-99.505 -266.498)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_28_",
    cx: 3.035,
    cy: 3.035,
    r: 3.035,
    transform: "translate(54.633 78.896)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_93_",
    d: "M230.552,418.223a9.1,9.1,0,0,0,18.207,0V406.085H230.552Z",
    transform: "translate(-151.643 -266.499)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_92_",
    d: "M177.013,88.018A87.983,87.983,0,0,1,131.5,165.095V151.743a18.207,18.207,0,0,0-11.106-16.75c23.244-7.95,35.382-26.036,35.382-53.589A74.2,74.2,0,0,0,149.7,51.574V33.4a3.035,3.035,0,1,0-6.069,0v7.192A65.019,65.019,0,0,0,89.012,12.156,65.021,65.021,0,0,0,34.391,40.589V33.4a3.035,3.035,0,0,0-3.035-3.035A3.1,3.1,0,0,0,28.838,31.7a2.96,2.96,0,0,0-.516,1.7V51.574A74.194,74.194,0,0,0,22.253,81.4c0,27.553,12.138,45.639,35.382,53.589a18.207,18.207,0,0,0-11.106,16.75v13.352A88,88,0,1,1,177.013,88.018Z",
    transform: "translate(-1 -0.019)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_91_",
    d: "M141.173,52.981c-34.593,0-60.69,27.159-60.69,63.178,0,34.594,20.422,52.133,60.69,52.133s60.69-17.539,60.69-52.133c0-36.019-26.1-63.178-60.69-63.178Zm-3.035,12.138h6.069a3.035,3.035,0,1,1,0,6.069h-6.069a3.035,3.035,0,1,1,0-6.069Zm-6.069,9.1h18.207a3.035,3.035,0,0,1,0,6.069H132.07a3.035,3.035,0,1,1,0-6.069Zm27.31,84.966H122.966a36.414,36.414,0,1,1,0-72.828H159.38a36.414,36.414,0,0,1,0,72.828Z",
    transform: "translate(-53.16 -34.775)",
    fill: "#4c85f7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.4a78e4b1fc2f6b4f695c1ace7f9ffdbc.svg";
export { ForwardRef as ReactComponent };